import React from 'react';
import { CheckCircleIcon, SparklesIcon } from 'lucide-react';
export function SolutionSection() {
  const features = ['Qué darle según su edad', 'Qué textura es segura', 'Qué cocinar hoy', 'Y cómo organizarte sin volverte loca'];
  return <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-br from-baby-pink-light via-baby-lavender to-baby-blue-light" data-id="element-1155">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-1156">
        <div className="text-center mb-8 sm:mb-12 animate-fade-in-up" data-id="element-1157">
          <div className="inline-flex items-center gap-2 bg-white/90 backdrop-blur-baby text-baby-blue px-4 py-2 sm:px-6 sm:py-3 rounded-full mb-4 shadow-baby-soft border-2 border-baby-blue-light" data-id="element-1158">
            <SparklesIcon className="w-5 h-5" data-id="element-1159" />
            <span className="font-bold text-sm sm:text-base" data-id="element-1160">La Solución</span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-1161">
            Un Plan Que Funciona
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-1162">
            Imagina tener en tus manos una guía que te diga:
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-4 sm:gap-6 mb-8 sm:mb-12 stagger-children" data-id="element-1163">
          {features.map((feature, index) => <div key={index} className="bg-white/90 backdrop-blur-baby p-5 sm:p-6 rounded-baby-lg border-2 border-baby-lavender shadow-baby-glow hover:scale-105 transition-all" data-id="element-1164">
              <div className="flex items-center gap-3" data-id="element-1165">
                <div className="flex-shrink-0 w-8 h-8 bg-baby-gradient-blue rounded-full flex items-center justify-center shadow-baby-soft" data-id="element-1166">
                  <CheckCircleIcon className="w-5 h-5 text-white" data-id="element-1167" />
                </div>
                <p className="text-base sm:text-lg font-semibold text-gray-800" data-id="element-1168">
                  {feature}
                </p>
              </div>
            </div>)}
        </div>

        <div className="bg-baby-gradient-pink-blue p-6 sm:p-8 md:p-10 rounded-baby-lg text-white shadow-baby-glow animate-fade-in-up" style={{
        animationDelay: '0.4s'
      }} data-id="element-1169">
          <div className="text-center mb-6" data-id="element-1170">
            <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-3" data-id="element-1171">
              Eso es este ebook:
            </h3>
            <p className="text-3xl sm:text-4xl md:text-5xl font-bold mb-2" data-id="element-1172">
              "30 Recetas para bebés"
            </p>
            <p className="text-lg sm:text-xl md:text-2xl font-medium opacity-95" data-id="element-1173">
              Método Paso a Paso para mamás primerizas
            </p>
          </div>

          <div className="bg-white/20 backdrop-blur-baby p-5 sm:p-6 rounded-baby border-2 border-white/30" data-id="element-1174">
            <p className="text-xl sm:text-2xl font-bold text-center mb-4" data-id="element-1175">
              Es más que recetas. Es tranquilidad en PDF.
            </p>
            <p className="text-base sm:text-lg text-center opacity-95" data-id="element-1176">
              Diseñado para mamás de Latinoamérica que:
            </p>
            <div className="grid sm:grid-cols-3 gap-3 mt-4" data-id="element-1177">
              <div className="text-center bg-white/10 backdrop-blur-baby p-3 rounded-baby" data-id="element-1178">
                <p className="font-semibold" data-id="element-1179">Quieren dejar de improvisar</p>
              </div>
              <div className="text-center bg-white/10 backdrop-blur-baby p-3 rounded-baby" data-id="element-1180">
                <p className="font-semibold" data-id="element-1181">Tienen miedo a las texturas</p>
              </div>
              <div className="text-center bg-white/10 backdrop-blur-baby p-3 rounded-baby" data-id="element-1182">
                <p className="font-semibold" data-id="element-1183">
                  Están cansadas de tener mil ideas y cero plan
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}